<template>
    <validator name="validator">
        <form novalidate>
            <div class="card card-content">
                <div class="card-header">
                    <div class="header">
                      <div class="breadcrumb">
                        <a class="breadcrumb-item" v-link="{path: '/'}">Accueil</a>
                        <a class="breadcrumb-item" v-link="{ path: '/contact/list'}">Gestion des participants</a>
			<a class="breadcrumb-item" v-link="{ path: '/contact/add'}">Ajouter</a>
                      </div>
                      <h1>Ajouter un participant</h1>
                    </div>
                    <div class="actions">
                        <a class="btn btn-link" v-link="{ path: '/contact/list' }">Voir tous les participants</a>
                        <button class="btn btn-link" v-on:click.prevent="saveContact" :class="{ disabled: !$validator.valid }">Sauvegarder le participant</button>
                    </div>
                </div>
                <div class="card-block">
                    <fieldset>
                        <legend>Informations générales</legend>
                        <div class="row">
                            <div class="col-sm-6">
                                <label for="gender">Civilité *</label>
                                <select id="gender" name="gender" v-model="contact.gender" class="form-control" v-validate:gender = "validationRules.gender">
                                    <option value=""></option>
                                    <option v-for="gender in genders" :value="gender.value">{{ gender.label }}</option>
                                </select>
                                <small class="form-text text-danger" v-if="$validator.gender.required">Vous devez choisir un titre</small>
                            </div>
                            <div class="col-sm-6">
                                <!-- Firstname -->
                                <div class="form-group">
                                  <label for="leader_firstname">Prénom *</label>
                                  <input class="form-control"
                                                 id="leader_firstname"
                                                 type="text"
                                                 v-model="contact.leader_firstname"
                                                 v-validate:leader_firstname="validationRules.leader_firstname"
                                  >
                                  <small class="form-text text-danger" v-if="$validator.leader_firstname.required">Vous devez indiquer
                                        un nom
                                  </small>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-6">
                                <!-- Lastname -->
                                <div class="form-group">
                                    <label for="leader_lastname">Nom d'usage *</label>
                                    <input class="form-control"
                                           id                         = "leader_lastname"
                                           type                       = "text"
                                           v-model                    = "contact.leader_lastname"
                                           v-validate:leader_lastname = "validationRules.leader_lastname"
                                           v-uppercase                = "contact.leader_lastname"
                                    >
                                    <small class="form-text text-danger" v-if="$validator.leader_lastname.required">Vous devez indiquer un nom</small>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <!-- Lastname -->
                                <div class="form-group">
                                    <label for="leader_lastname">Nom de jeune fille</label>
                                    <input class="form-control"
                                           id                         = "nom_origin"
                                           type                       = "text"
                                           v-model                    = "contact.nom_origin"
                                           v-validate:nom_origin      = "validationRules.nom_origin"
                                           v-uppercase                = "contact.nom_origin"
                                    >
                                </div>
                            </div>
                        </div>

                            <div class="row">
                            <div class="col-sm-6">
                              <!-- Phone -->
                              <div class="form-group">
                                <label for="phone">Téléphone</label>
                                <input class="form-control"
                                       id="phone"
                                       type="text"
                                       v-model="contact.phone"
                                       v-validate:phone="validationRules.phone"
                                >
                                <small class="form-text text-danger" v-if="$validator.phone.validatePhone">Vous devez indiquer un
                                  téléphone valide
                                </small>
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <!-- Mobile -->
                              <div class="form-group">
                                <label for="mobile">Portable</label>
                                <input class="form-control"
                                       id="mobile"
                                       type="text"
                                       v-model="contact.mobile"
                                       v-validate:mobile="validationRules.mobile"
                                >
                                <small class="form-text text-danger" v-if="$validator.mobile.validatePhone">Vous devez indiquer un
                                  téléphone mobile valide
                                </small>
                              </div>
                            </div>
                          </div>


                            <div class="row">
                            <div class="col-sm-6">
                              <!-- Email -->
                              <div class="form-group">
                                <label for="email">Email</label>
                                <input class="form-control"
                                       id="email"
                                       type="text"
                                       v-model="contact.email"
                                       v-validate:email="validationRules.email">
                                <small class="form-text text-danger" v-if="$validator.email.validateEmail">L'adresse email fournie n'est pas valide</small>
                              </div>
                            </div>
                          </div>


                        <div class="row">
                          <div class="col-sm-6">
                            <!-- Birth date -->
                            <div class="form-group">
                              <label for="startTime">Date de naissance</label>
                              <!--
                              <date-picker
                                :time.sync="contact.date_birth"
                                :option="datepickerOptions"
                                :inputClass="form-control"
                              ></date-picker>
                             -->
                             <input
                               id               = "date_birth"
                               class            = "form-control"
                               type             = "text"
                               v-model          = "contact.date_birth"
                             >
                            </div>
                          </div>
                                      <div class="col-sm-6">
                            <!-- Birth city -->
                            <div class="form-group">
                              <label for="city_birth">Ville de naissance</label>
                              <input class="form-control"
                                     id="city_birth"
                                     type="text"
                                     v-model="contact.city_birth"
                              >
                            </div>
                          </div>

                        </div>


			<div class="row">
                            <div class="col-sm-6">
                              <!-- Birth country -->
                              <div class="form-group">
                                <label for="country_id">Pays de naissance</label>
                                <select id="country_id" name="country_id" v-model="contact.country_id" class="form-control">
                                  <option value=""></option>
                                  <option v-for="country in countries" v-bind:value="country.id">{{ country.name }}</option>
                                </select>
                              </div>
                            </div>
                                        <div class="col-sm-6">
                              <!-- Nationality -->
                              <div class="form-group">
                                <label for="nationality">Nationalité</label>
                                <input class="form-control"
                                       id="nationality"
                                       type="text"
                                       v-model="contact.nationality"
                                >
                              </div>
                            </div>
                          </div>

                    </fieldset>
                    <fieldset>
                    <legend>Adresse</legend>

                    <div class="row">
                      <div class="col-sm-6">
                        <!-- Address -->
                        <div class="form-group">
                          <label for="email">Adresse</label>
                          <input class="form-control"
                                 id="address"
                                 type="text"
                                 v-model="contact.address"
                                 v-validate:address="validationRules.address"
                          >
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <!-- Address complement -->
                        <div class="form-group">
                          <label for="address_compl">Complément</label>
                          <input class="form-control"
                                 id="address_compl"
                                 type="text"
                                 v-model="contact.address_compl"
                          >
                        </div>
                      </div>
                                  </div>
                                  <div class="row">
                      <div class="col-sm-6">
                        <!-- zip -->
                        <div class="form-group">
                          <label for="zip">Code postal</label>
                          <input class="form-control"
                                 id="zip"
                                 type="text"
                                 v-model="contact.zip"
                                 v-validate:zip="validationRules.zip"
                          >
                          <small class="form-text text-danger" v-if="$validator.zip.minLength || $validator.zip.maxLength">Vous
                            devez indiquer un code postal valide
                          </small>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <!-- City -->
                        <div class="form-group">
                          <label for="city">Ville</label>
                          <input class="form-control"
                                 id="city"
                                 type="text"
                                 v-model="contact.city"
                                 v-validate:city="validationRules.city"
                          >
                        </div>
                      </div>
                    </div>
			              <div class="row">
                        <div class="col-sm-6">
                        <!-- political_district -->
                            <div class="form-group">
                             <switch :value.sync = "contact.political_district" >Quartier politique de la ville</switch>
                            </div>
                        </div>
                        <div class="col-sm-6">
                          <!-- political_district complement -->
                          <label for="political_district_complement">Complément quartier politique</label>
                          <div class="form-group">
                            <input class="form-control"
                                  id="political_district_complement"
                                  type="text"
                                  v-model="contact.political_district_complement"
                            >
                          </div>
                      </div>
			              </div>
                  </fieldset>
                    <fieldset>
                        <legend>Activité</legend>
                        <div class="row">
                            <div class="col-sm-6">
                                <!-- Education level -->
                                <div class="form-group">
                                    <label for="education_level_id">Niveau de formation</label>
                                    <select id="education_level_id" v-model="contact.education_level_id" class="form-control">
                                        <option value=""></option>
                                        <option v-for="educationLevel in educationLevels" :value="educationLevel.id">{{ educationLevel.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <!-- Driving licence -->
                                <div class="">
                                    <switch :value.sync = "contact.driving_licence" >Permis de conduire</switch>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <!-- Job title -->
                                <div class="form-group">
                                    <label for="job_title">Métier</label>
                                    <input class="form-control"
                                           id      = "job_title"
                                           type    = "text"
                                           v-model = "contact.job_title"
                                    >
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <!-- PE identifiant -->
                                <div class="form-group">
                                    <label for="ipe_num">N° identifiant PE</label>
                                    <input class="form-control"
                                           id      = "ipe_num"
                                           type    = "text"
                                           v-model = "contact.ipe_num"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <!-- Sector -->
                                <div class="form-group">
                                    <label for="sector">Secteur d'activité</label>
                                    <select id="sector" v-model="contact.sector_id" class="form-control">
                                        <option value=""></option>
                                        <option v-for="sector in sectors" :value="sector.id">{{ sector.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <!-- Subsector -->
                                <div class="form-group" v-if="contact.sector_id" >
                                    <label for="sub_sector_id">Secteur d'activité complémentaire</label>
                                    <select id="sub_sector_id" name="sub_sector_id" v-model="contact.sub_sector_id" class="form-control">
                                        <option value=""></option>
                                        <option v-for="sector in sectors" :value="sector.id">{{ sector.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 social_status">
                                <!-- Social status -->
                                <div class="form-group">
                                    <label>Statut social</label>
                                    <div v-for="socialStatus in socialStatusesList">
                                      <switch :value.sync="socialStatus.selected">{{ socialStatus.name }}</switch>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <!-- Social security number -->
                                <div class="form-group">
                                    <label for="ss_num">N° sécu</label>
                                    <input class="form-control"
                                           id      = "ss_num"
                                           type    = "text"
                                           v-model = "contact.ss_num"
                                           v-validate:ss_num="validationRules.ss_num"
                                    >
                                    <small class="form-text text-danger" v-if="$validator.ss_num.validateSecu">Vous devez indiquer un
                                    numéro de sécu valide
                                    </small>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <!-- CAF number -->
                                <div class="form-group">
                                    <label for="caf_num">N° allocation CAF</label>
                                    <input class="form-control"
                                           id      = "caf_num"
                                           type    = "text"
                                           v-model = "contact.caf_num"
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <!-- Allowance -->
                                <div class="form-group">
                                    <label for="allowance">Allocation</label>
                                    <select id="allowance" name="allowance_id" v-model="contact.allowance_id" class="form-control">
                                        <option value=""></option>
                                        <option v-for="allowance in allowances" :value="allowance.id">{{ allowance.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <!-- Allowance precisions -->
                                <div class="form-group">
                                    <label for="allowances_precisions">Allocation (Précision)</label>
                                    <input class="form-control"
                                           id      = "allowances_precisions"
                                           type    = "text"
                                           v-model = "contact.allowances_precisions"
                                    >
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset>
                        <legend>Situation familiale</legend>
                        <div class="row">
                            <div class="col-sm-6">
                                <!-- Family situation -->
                                <div class="form-group">
                                    <label for="family_situation">Situation familiale</label>
                                    <select id="family_situation" name="family_situation_id" v-model="contact.family_situation_id" class="form-control">
                                        <option value=""></option>
                                        <option v-for="familySituation in familySituations" :value="familySituation.id" >{{ familySituation.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <!-- Partner situation -->
                                <div class="form-group">
                                    <label for="partner_situation">Situation conjoint</label>
                                    <select id="partner_situation" name="partner_situation_id" v-model="contact.partner_situation_id" class="form-control">
                                        <option value=""></option>
                                        <option v-for="partnerSituation in partnerSituations" :value="partnerSituation.id">{{ partnerSituation.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <!-- Number of childs -->
                                <div class="form-group">
                                    <label for="nbchilds">Enfants à charge</label>
                                    <input class="form-control"
                                           id      = "nbchilds"
                                           type    = "number"
                                           size    = "2"
                                           v-model = "contact.nbchilds"
                                    >
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset>
                        <legend>Problématiques</legend>
                        <div class="form-group">
                        <div class="col-sm-12 social_status">
                            <div v-for="problematique in problematiquesList">
                                <switch :value.sync="problematique.selected">{{ problematique.name }}</switch>
                            </div>
                        </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6" v-for="issue in issuesList" >
                                <div class="">
                                    <switch :value.sync = "issue.value">{{ issue.name }}</switch>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                          <div class="col-sm-12" v-for="autre in contact.autre_problematique">
                            <div class="form-group">
                              <div class="input-group">
                                <input type="text" class="form-control" v-model="autre">
                                <span class="input-group-btn">
                                  <button class="btn btn-warning" v-on:click.prevent="delAutreProblematique(autre)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-12"><button class="btn btn-secondary" v-on:click.prevent="addAutreProblematique()">Autre choix</button></div>
                        </div>
                    </fieldset>
                    <br>
                    <fieldset>
                        <legend>Observations</legend>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <textarea rows="10" id="observations" v-model="contact.observations" placeholder="" class="form-control"></textarea>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>
                <div class="card-footer">
                    <div class="actions">
                        <a class="btn btn-link" v-link="{ path: '/contact/list'}">Voir tous les participants</a>
                        <button class="btn btn-link" v-on:click.prevent="saveContact" v-if="$validator.valid">Sauvegarder le participant</button>
                    </div>
                </div>
            </div>
        </form>
    </validator>
</template>

<script>
// Npm packages
import toastr from 'toastr'
import DatePicker from 'vue-datepicker/vue-datepicker-1.vue'
import { Switch } from 'mint-ui'
import Breadcrumb from '../nav/Breadcrumb.vue'

import moment from 'moment'

// Vuex
import { addContact } from 'src/vuex/actions/contactActions'
import {
  issues,
  sectors,
  countries,
  allowances,
  subSectors,
  socialStatuses,
  problematiques,
  educationLevels,
  familySituations,
  partnerSituations
} from 'src/vuex/getters'
import { getIssues } from 'src/vuex/actions/issuesActions'
import { getSectors } from 'src/vuex/actions/sectorsActions'
import { getCountries } from 'src/vuex/actions/countriesActions'
import { getAllowances } from 'src/vuex/actions/allowancesActions'
import { getSubSectors } from 'src/vuex/actions/subSectorsActions'
import { getSocialStatuses } from 'src/vuex/actions/socialStatusesActions'
import { getProblematiques } from 'src/vuex/actions/problematiquesActions'
import { getFamilySituations } from 'src/vuex/actions/familySituationsActions'
import { getEducationLevels } from 'src/vuex/actions/educationLevelsActions'
import { getPartnerSituations } from 'src/vuex/actions/partnerSituationsActions'

// Validations
import { add as validationRules } from 'src/validations/contact.js'
import { validateEmail, validatePhone, validateDate, validateSecu } from 'src/validations/customRules.js'

// Options
import { datepickerOptions } from 'src/options/date'

export default{
  vuex: {
    getters: {
      issues,
      sectors,
      countries,
      subSectors,
      allowances,
      socialStatuses,
      problematiques,
      educationLevels,
      familySituations,
      partnerSituations,
      contactCreated: ({ contacts }) => contacts.contactCreated
    },
    actions: {
      getIssues,
      addContact,
      getSectors,
      getCountries,
      getAllowances,
      getSubSectors,
      getSocialStatuses,
      getProblematiques,
      getEducationLevels,
      getFamilySituations,
      getPartnerSituations
    }
  },
  validators: {
    validatePhone,
    validateEmail,
    validateDate,
    validateSecu
  },
  data () {
    return {
      datepickerOptions,
      genders: [
        { label: 'Mme', value: '2' },
        { label: 'M', value: '3' }
      ],
      contact: {
        issue_contact: [],
        autre_problematique: []
      },
      issuesList: [],
      socialStatusesList: [],
      problematiquesList: [],
      validationRules
    }
  },
  created () {},
  watch: {
    'contact.sector_id' (value) {
      this.getSubSectors(value)
    },
    'contactCreated': function (value) {
      if (value !== false) {
        toastr.success('Nouveau contact ajouté')
        this.$router.go('/contact/edit/' + this.contactCreated)
      }
    },
    'issues': function () {
      this.issuesList = []
      let list = []
      this.issues.forEach(function (issue) {
        let selected = false
        list.push({ id: issue.id, name: issue.name, value: selected })
      })
      this.issuesList = list
    },
    'socialStatuses': function () {
      let list = []
      this.socialStatuses.forEach(function (el) {
        el.selected = false
        list.push(el)
      })
      this.socialStatusesList = list
    },
    'problematiques': function () {
      let list = []
      this.problematiques.forEach(function (el) {
        el.selected = false
        list.push(el)
      })
      this.problematiquesList = list
    }
  },
  methods: {
    saveContact () {
      this.contact.issue = this.issuesList
      this.contact.social_statuses = this.socialStatusesList
      this.contact.problematiques = this.problematiquesList
      if (typeof (this.contact.date_birth) === 'undefined' || this.contact.date_birth === null || this.contact.date_birth === '' || this.contact.date_birth === 'undefined' || this.contact.date_birth === 'Invalid date') {
        this.contact.date_birth = ''
      } else {
        this.contact.date_birth = moment(this.contact.date_birth, 'DD/MM/YYYY').format('DD-MM-YYYY')
      }
      this.addContact(this.contact)
    },
    updateSelectedCity (value) { this.selectedCity = value },
    addAutreProblematique () {
      if (!Array.isArray(this.contact.autre_problematique)) {
        this.contact.autre_problematique = []
      }
      this.contact.autre_problematique.push('')
    },
    delAutreProblematique (value) {
      this.contact.autre_problematique = this.contact.autre_problematique.filter(function (el) {
        return el !== value
      })
    }
  },
  components: { 'date-picker': DatePicker, Switch, Breadcrumb },
  ready () {
    this.$dispatch('preview-data', [])

    this.getEducationLevels()
    this.getSectors()
    this.getAllowances()
    this.getIssues()
    this.getCountries()
    this.getFamilySituations()
    this.getPartnerSituations()
    this.getSocialStatuses()
    this.getProblematiques()
  }
}
</script>

<style lang="scss">
//affichage lineaire des checkbox
.social_status .mint-switch{
    margin-top:0px!important;
    float:left;
    width:auto;
    margin-right:20px;
}

//correction hauteur du textes des liste deroulante
.form-control {
    font-size: 0.95rem;
}
</style>




// WEBPACK FOOTER //
// ContactAdd.vue?78068342